import { goto } from "./ouvrage.goto";
export * from "./OuvrageRoutes";

export const ouvrageRoute = {
  goto: goto,
};
